import React, { useState, useEffect, useRef, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Grid, CircularProgress, IconButton, MenuItem, Menu, ListItemIcon, ListItemText,
          Dialog,
          DialogActions,
          DialogContent,
          DialogContentText,
          DialogTitle,
          Button,
          Tooltip,
          TableRow,
          TableCell,
        } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { useTheme } from "@material-ui/styles";

import debounce from 'lodash.debounce';
// components
import PageTitle from "../../components/PageTitle";
import CustomerDownloadCSVConfirmation from '../../components/CustomerDownloadCSVConfirmation/CustomerDownloadCSVConfirmation';

// Icons
import {
    Add as AddIcon,
    MoreVert as MoreVertIcon,
    Send as SendIcon,
    CardMembership as CardMembershipIcon,
    RemoveCircle as RemoveCircleIcon,
    MonetizationOn as MonetizationOnIcon,
    History as HistoryIcon,
    Business as BusinessIcon,
    VpnKey as VpnKeyIcon,
    TrackChanges as TrackChangesIcon,
    AccountCircle as AccountCircleIcon
} from '@material-ui/icons'

import useStyles from './styles';
import config from '../../config';
import { sendNotification } from "../../context/UserContext";
import { useUserState } from "../../context/UserContext";
import CreateCustomer from '../../components/Customer/CreateCustomer';
import CreateSite from '../../components/Site/CreateSite';
import './customers.css'

const Customers = forwardRef((props, ref) => {
//export default function Jobs() {
  // global
  const classes = useStyles();
  const history = useHistory();
  var { single_phase_price, three_phase_price, rcd_price,
        fire_price, first_aid_price, medical_price, rcd_pb_price,
        lg_pb_price, lg_m_price, three_phase_rcd_price, microwave_price,
        non_electrical_price, ladder_price, aed_price, evse_price,
        hourly_charge, min_charge, local_travel, seventy_hundred_travel,
        over_100_travel, min_cash_charge, testing_scopes } = useUserState();

  // local
  var [data, setData] = useState([]);
  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  var [isLoading, setIsLoading] = useState(false);
  const [openResetXeroContactDialog, setOpenResetXeroContactDialog] = useState(false);
  const [isResetingXeroContact, setIsResetingXeroContact] = useState(false);
  const [searchText, setSearchText] = useState('');
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;
  const [openCreateCustomerDialog, setOpenCreateCustomerDialog] = useState(false);
  const createCustomerRef = useRef(null);
  const [isCreateCustomerValid, setIsCreateCustomerValid] = useState(false);
  const [isCreatingCustomer, setIsCreatingCustomer] = useState(false);
  const [createdCustomer, setCreatedCustomer] = useState({
    id: -1,
    name: undefined,
    company: null,
    contact: null,
    phone: null,
    mobile: null,
    fax: null,
    email: null,
    address: null,
    notes: null,
    mapurl: null,
    testing_scopes: null,
    require_vaccination_proof: false,
    covid_policy: null,
    po_required: false,
    jsa_required: false,
    microwave_only: false,
    service_level_agreement: false,
    agreement_start_date: null,
    agreement_send_date: null,
    price_change_date: new Date().toLocaleDateString('en-NZ').split('/').reverse().join('-'),
    single_phase_price: single_phase_price,
    three_phase_price: three_phase_price,
    rcd_price: rcd_price,
    fire_price: fire_price,
    first_aid_price: first_aid_price,
    medical_price: medical_price,
    rcd_pb_price: rcd_pb_price,
    lg_pb_price: lg_pb_price,
    lg_m_price: lg_m_price,
    three_phase_rcd_price: three_phase_rcd_price,
    microwave_price: microwave_price,
    non_electrical_price: non_electrical_price,
    ladder_price: ladder_price,
    aed_price: aed_price,
    evse_price: evse_price,
    hourly_charge: hourly_charge,
    min_charge: min_charge,
    local_travel: local_travel,
    seventy_hundred_travel: seventy_hundred_travel,
    over_100_travel: over_100_travel,
    min_cash_charge: min_cash_charge,
    repair_email: null,
    health_safety_email: null,
    xero_contact_id: null,
    active: true
  });

  const customerDownloadCSVConfirmationRef = useRef(null);
  const [openCreateSiteDialog, setOpenCreateSiteDialog] = useState(false);
  const createSiteRef = useRef(null);
  const [isCreateSiteValid, setIsCreateSiteValid] = useState(false);
  const [isCreatingSite, setIsCreatingSite] = useState(false);
  const [createdSite, setCreatedSite] = useState({
    id: -1,
    customer_id: -1,
    name: null,
    code: null,
    contact: null,
    phone: null,
    email: null,
    address: null,
    notes: null,
    mapurl: null,
    active: true
  });

  const theme = useTheme();

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:active': {
          backgroundColor: theme.palette.primary.main,
          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
            color: theme.palette.common.white,
          },
        },
      },
    }))(MenuItem);




  const [columns, setColumns] = useState([
    { label: 'ID', name: 'id', options: {filter: false, display: true}},
    { label: 'Customer', name: 'customer', options: {filter: false, display: true} },
    { label: 'Company', name: 'Company', options: {filter: false, display: true}},
    { label: 'Booking Instructions', name: 'booking_instructions', options: {filter: false, sort: false, display: true}},
    { label: 'Services',
      name: 'services',
      options: {
        filter: true,
        display: true,
        sort: false,
        filterOptions: {names:testing_scopes === undefined || testing_scopes === null ? []  : testing_scopes.map(s => s.name)},
        customBodyRender: (value, tableMeta) => {
          return (<div>{value === undefined || value === null ? '' : value.join(',')}</div>);
        },
      }},
      { label: 'Agreement',
        name: 'agreement_start_date',
        options: {
          filter: true,
          display: true,
          sort: false,
          filterOptions: {
            names: ['YES', 'NO'],
            logic(value, filters) {
              if (!filters || filters.length === 0) {
                return false;
              }

              const normalized = value !== undefined && value !== null && value !== '' ? 'YES' : 'NO';
              return !filters.includes(normalized);
            }
          },
          customFilterListOptions: {
            render: (v) => `Service Level Agreement: ${v}`
          },
        }},
    { label: 'CPI', name: 'customer_cpi_percentage', options: {filter: false, display: true, sort: false}},
    { label: 'CPI hidden', name: 'customer_cpi_percentage_hidden', options: {filter: false, display: false, sort: false, download: false}},
    { label: 'CPI Quarter', name: 'customer_cpi_quarter', options: {filter: false, display: false}},
    { label: 'CPI Last Applied', name: 'last_applied', options: {filter: false, display: false}},
    { label: 'CPI Needs Update',
      name: 'update_needed',
      options: {
        filter: true,
        display: false,
        sort: false,
        filterOptions: {names:['YES', 'NO']},
        customFilterListOptions: { render: (v) => {return `CPI Needs Update: ${v}`} },}},
    { label: 'Active',
      name: 'active',
      options: {
        filter: true,
        display: true,
        filterList: (localStorage.getItem('customers_filter_list') === undefined || localStorage.getItem('customers_filter_list') === null || JSON.parse(localStorage.getItem('customers_filter_list'))[12] === null || JSON.parse(localStorage.getItem('customers_filter_list'))[12] === undefined || JSON.parse(localStorage.getItem('customers_filter_list'))[12].length === 0) ? [] : JSON.parse(localStorage.getItem('customers_filter_list'))[12],
        customFilterListOptions: {
                  render: v => {
                    return `Active: ${v}`;
                  },
        }
      }
    },
    { label: 'Hourly',
      name: 'is_hourly',
      options: {
        filter: true,
        display: true,
        customFilterListOptions: {
                  render: v => {
                    return `Hourly: ${v}`;
                  },
        }}},
    {
      label: 'Xero Contact ID',
      name: 'xero_contact_id',
      options: {
        filter: false,
        display: false,
        download: false,
      }
    },
    { label: 'KPI Customer',
      name: 'kpi_customer',
      options: {
        filter: true,
        display: false,
        download: false,
        filterOptions: { names: ['YES', 'NO'] },
        customFilterListOptions: {
          render: v => `KPI Customer: ${v}`,
        },
      }
    },
    { label: 'Key Customer',
      name: 'key_customer',
      options: {
        filter: true,
        display: false,
        download: false,
        filterOptions: { names: ['YES', 'NO'] },
        customFilterListOptions: {
          render: v => `Key Customer: ${v}`,
        },
      }
    },
    {
      label: 'Portal Access',
      name: 'has_portal_access',
      options: {
        filter: true,
        display: false,
        download: false,
        filterOptions: {
          names: ['YES', 'NO']
        },
        customFilterListOptions: {
          render: v => `Portal Access: ${v}`,
        },
      }
    },
    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          display: true
        }
      }
  ]);

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '0px 16px',
           },
       },
     }
   });


    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
         setIsLoading(true);
         var response = null;
         if (localStorage.getItem('customers_search_text') !== undefined && localStorage.getItem('customers_search_text') !== null) {
            if (localStorage.getItem('customers_search_text') !== 'null' && localStorage.getItem('customers_search_text') !== 'undefined') {
                response = await ttAPI.getAllCustomersByKey(localStorage.getItem('customers_search_text'));
            }
            else {
                response = await ttAPI.getAllCustomers();
            }
         }

         if (response === null) {
           response = await ttAPI.getAllCustomers();
         }
         if(mounted){
            setData(response);
            setIsLoading(false);
         }
       };
       fetchData();

       return () => mounted = false;

    }, []);

    useEffect(() => {
       if (openCreateSiteDialog) {
           // pre-set customer id to new site
           setCreatedSite({
             ...createdSite,
             customer_id: data[selectedRowIndex].id,
           });
       }

    }, [openCreateSiteDialog]);


    function viewCustomerForecast() {
      window.open(
      `${config.clientApi}/reports/forecast.pdf?customer_id=${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

    const downloadCustomerAssetsCSV = () => {
      customerDownloadCSVConfirmationRef.current.openConfirmationPopup(data[selectedRowIndex].id, data[selectedRowIndex].customer);
      handleClose();
    }

    function downloadCustomerCostEstimatorCSV() {
      window.open(
      `${config.clientApi}/reports/customer_cost_estimator?id=${data[selectedRowIndex].id}`,
      '_blank'
      );
      handleClose();
    }

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setIsMenuOpen(true);
    };

    const handleClose = () => {
      setAnchorEl(null);
      setSelectedRowIndex(-1);
      setIsMenuOpen(false);
    };

    const handleCloseResetXeroContactDialog = () => {
      setOpenResetXeroContactDialog(false);
      //handleClose();
    };

    const resetXeroContact = async () => {

        setIsResetingXeroContact(true);
        const response = await ttAPI.resetXeroContact(data[selectedRowIndex].id);
        setIsResetingXeroContact(false);
        if (response) {
          await refreshData();
          sendNotification('success', 'Success - Xero Contact Removed Successfully.', classes);
          setOpenResetXeroContactDialog(false);
        }
        else {
          sendNotification('error', 'Error - Error Removing Xero Contact.', classes);
        }

    }

    function resetXeroContactConfirmation() {
      setIsMenuOpen(false);
      setAnchorEl(null);
      setOpenResetXeroContactDialog(true);
    }

    async function refreshData() {
      const response = await ttAPI.getAllCustomers();
      setData(response);
    }

    async function onSearchKey(key) {
      if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
        const response = await ttAPI.getAllCustomersByKey(key);
        if (response !== null) {
            setData(response);
        }
        else {
            setData([]);
        }
      }
      else {
        refreshData();
      }
    };

    const downloadHistory = () => {
      window.open(`${config.clientApi}/reports/audit/customer?id=${data[selectedRowIndex].id}`,'_blank');
    }

    const downloadPricingHistory = () => {
      window.open(`${config.clientApi}/reports/audit/pricing/customer?id=${data[selectedRowIndex].id}`,'_blank');
    }

    const handleCloseCreateCustomerDialog = () => {
        setOpenCreateCustomerDialog(false);
    };

    function onCreateCustomerFormUpdated(isValid) {
      setIsCreateCustomerValid(isValid);
    }

    function onCreateCustomerUpdated(customer) {
      setCreatedCustomer(customer);
    }

    function onCustomerCreated(customer, isUpdate, customerId) {
      sendNotification('success', isUpdate ? 'Success - Customer Updated.' : 'Success - Customer Created.', classes);
      setCreatedCustomer(customer);
      history.push({pathname:`/app/customer/edit/${customerId}`,
                                       state:{customerId: customerId}
                                     });
    }

    function handleOpenCreateCustomerDialog() {
      setOpenCreateCustomerDialog(true);
    }

    function createCustomer() {
      if (createCustomerRef !== null && createCustomerRef.current !== null) {
          createCustomerRef.current.saveCustomer();
      }
    }

    const handleCloseCreateSiteDialog = () => {
        setOpenCreateSiteDialog(false);
    };

    function onCreateSiteFormUpdated(isValid) {
      setIsCreateSiteValid(isValid);
    }

    function onCreateSiteUpdated(site) {
    }

    function onSiteCreated(site, isUpdate, siteId) {
      sendNotification('success', isUpdate ? 'Success - Site Updated.' : 'Success - Site Created.', classes);
      history.push({pathname:`/app/site/edit/${siteId}`,
                                       state:{siteId: siteId}
                                     });
    }

    function handleOpenCreateSiteDialog() {
      setOpenCreateSiteDialog(true);
    }

    function createSite() {
      if (createSiteRef !== null && createSiteRef.current !== null) {
          createSiteRef.current.saveSite();
      }
    }

    const onCellClick = (dataIndex, colIndex) => {
      setSelectedRowIndex(dataIndex);
      if (!isMenuOpen) {
        if (colIndex !== columns.length - 1 ) {
          history.push({pathname:`/app/customer/edit/${data[dataIndex].id}`,
                                           state:{customerId: data[dataIndex].id}
                                         })
        }
      }
    }



  return (
    <>
    {data !== undefined && data !== null && selectedRowIndex >= 0 &&
      data[selectedRowIndex].xero_contact_id !== undefined && data[selectedRowIndex].xero_contact_id !== null &&
      data[selectedRowIndex].xero_contact_id !== '' &&
      <Dialog open={openResetXeroContactDialog} onClose={handleCloseResetXeroContactDialog} disableBackdropClick={true}

          PaperProps={{
            style: {
              boxShadow: 'none',
            },
          }}
      >
        <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
             {`You are about to reset Xero contact for ${data[selectedRowIndex].customer} (${data[selectedRowIndex].id}).`}
          </DialogContentText>

        </DialogContent>
        <DialogActions>
            <Button onClick={handleCloseResetXeroContactDialog}>
              Cancel
            </Button>
            <Button onClick={resetXeroContact} disabled={isResetingXeroContact}>
              {isResetingXeroContact && <span><CircularProgress size={25} color={'inherit'} /> Resetting...</span>}
              {!isResetingXeroContact && <span>RESET</span>}
            </Button>
        </DialogActions>
      </Dialog>
    }
      <PageTitle title="Customers" />
      <Grid container spacing={4}>
      <Grid item xs={12}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title="&nbsp;"
            data={data !== undefined && data !== null ? data.map(item => {
                return [
                    item.id, //0
                    item.customer, //1
                    item.company, //2
                    item.booking_instructions, //3
                    item.services ? item.services.map(s => s.name) : null, //4
                    item.agreement_start_date ?? '', //5
                    item.customer_cpi_percentage, //6
                    item.customer_cpi_percentage, //7
                    item.customer_cpi_quarter, //8
                    item.last_applied,//9
                    (item.update_needed === undefined || item.update_needed === null ) ? '' : (item.update_needed ? 'YES' : 'NO'),//10
                    item.active ? 'YES' : 'NO',//11
                    item.is_hourly ? 'YES' : 'NO',//12
                    item.xero_contact_id,//13
                    item.kpi_customer ? 'YES' : 'NO', //14
                    item.key_customer ? 'YES' : 'NO', //15
                    item.has_portal_access ? 'YES' : 'NO', //16
                ]
            }) : []}
            columns={columns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              onChangeRowsPerPage: (numberOfRows) => {
                localStorage.setItem('customers_rows_per_page', numberOfRows);
              },
              rowsPerPageOptions: [10,15,20,50,100],
              searchOpen: true,
              print: false,
              viewColumns: true,
              selectableRows: 'none',
              //searchText: searchText,
              textLabels: { body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' }, },
              downloadOptions: {filterOptions:{useDisplayedColumnsOnly: true, useDisplayedRowsOnly: true}},
              /*onRowClick: row => history.push({pathname:`/app/customer/edit/${row[0]}`,
                                               state:{customerId: row[0]}
                                             })*/
             customToolbar: () => {
               return (
                  <Tooltip title="Create Customer">
                   <IconButton onClick={handleOpenCreateCustomerDialog}><AddIcon /></IconButton>
                   </Tooltip>
               );
             },
             onCellClick: (col, cellMeta) => {
               //console.log('selectedRowIndex set to ', cellMeta.dataIndex, isMenuOpen)
               if (!isMenuOpen) {
                 setSelectedRowIndex(cellMeta.dataIndex);
                 if (cellMeta.colIndex !== columns.length - 1) {
                   history.push({pathname:`/app/customer/edit/${data[cellMeta.dataIndex].id}`,
                                                    state:{customerId: data[cellMeta.dataIndex].id}
                                                  })
                 }
               }
             },
             onSearchChange: (searchText) => {
               localStorage.setItem('customers_search_text', searchText);
               delayedOnSearchKey(searchText);
             },
             customSearch: (searchQuery, currentRow, columns) => {
                return data.find(c=> c.id === currentRow[0]) !== undefined;
             },
             onSearchClose: () => {
                refreshData();
             },
             onChangePage:(currentPage) => {
               localStorage.setItem('customers_page', currentPage);
             },
             onTableInit: (action, tableState) => {
                 //console.log(action);
                 //console.log(tableState);

                if (localStorage.getItem('customers_filter_list') === undefined || localStorage.getItem('customers_filter_list') === null || JSON.parse(localStorage.getItem('customers_filter_list'))[12] === null || JSON.parse(localStorage.getItem('customers_filter_list'))[12] === undefined || JSON.parse(localStorage.getItem('customers_filter_list'))[12].length === 0) {
                   tableState.filterList[12] = ['YES'];
                   localStorage.setItem('customers_filter_list', JSON.stringify(tableState.filterList));
                 }

                 if (localStorage.getItem('customers_search_text') !== undefined && localStorage.getItem('customers_search_text') !== null) {
                    if (localStorage.getItem('customers_search_text') !== 'null' && localStorage.getItem('customers_search_text') !== 'undefined') {
                        tableState.searchText = localStorage.getItem('customers_search_text');
                    }
                 }

                 if (localStorage.getItem('customers_page') !== undefined && localStorage.getItem('customers_page') !== null) {
                   if (localStorage.getItem('customers_page') !== 'null' && localStorage.getItem('customers_page') !== 'undefined') {
                       tableState.page = parseInt(localStorage.getItem('customers_page'));
                   }
                 }

                 if (localStorage.getItem('customers_rows_per_page') !== undefined && localStorage.getItem('customers_rows_per_page') !== null &&
                     localStorage.getItem('customers_page') !== 'null' && localStorage.getItem('customers_page') !== 'undefined' &&
                     localStorage.getItem('customers_rows_per_page') >= 10) {
                       tableState.rowsPerPage = parseInt(localStorage.getItem('customers_rows_per_page'));
                 }
                 else {
                   tableState.rowsPerPage = 100;
                 }

                 // find if there are hidden columns set
                 if (localStorage.getItem('customers_columns_hide') !== undefined && localStorage.getItem('customers_columns_hide') !== null &&
                     JSON.parse(localStorage.getItem('customers_columns_hide')) !== undefined && JSON.parse(localStorage.getItem('customers_columns_hide')) !== null) {
                       // hide them on the current table
                       var columnsToHide = JSON.parse(localStorage.getItem('customers_columns_hide'));
                       for (let i = 0; i < columnsToHide.length; i++) {
                         if (tableState.columns.length > i && tableState.columns[i] !== undefined && tableState.columns[i] !== null) {
                             tableState.columns[i].display = false;
                         }
                       }

                       if (columnsToHide !== undefined && columnsToHide !== null && columnsToHide.length > 0) {
                         var newCols = columns.map((col, index) => {
                           let newCol = Object.assign({}, col);
                           newCol.options.display = !columnsToHide.includes(index);
                           return newCol;
                         });
                         setColumns(newCols);
                       }

                 }
             },
             customRowRender: (data, dataIndex, rowIndex) => {
                    return  (
                       <TableRow key={data[0]} id={rowIndex} className={classes.tableRow}
                       style={{backgroundColor: data[10] === 'YES' ? '#FFA50070' : '#FFFFFF'}}>
                           {columns[0].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 0)}>
                               <div>{data[0]}</div>
                           </TableCell>)}
                           {columns[1].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, 1)}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    {data[15] === 'YES' && (
                                        <Tooltip title="Key customer">
                                            <VpnKeyIcon style={{ fontSize: 18, color: '#d4a017' }} />
                                        </Tooltip>
                                    )}
                                    {data[14] === 'YES' && (
                                        <Tooltip title="KPI customer">
                                        <TrackChangesIcon
                                                style={{
                                                fontSize: 18,
                                                color: '#d4a017',
                                                }}
                                                />
                                        </Tooltip>
                                    )}
                                    {data[16] === 'YES' && (
                                        <Tooltip title="Customer portal account">
                                            <AccountCircleIcon
                                                style={{
                                                    fontSize: 18,
                                                    color: '#d4a017',
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                    <span>{data[1]}</span>
                                </div>
                            </TableCell>)}
                           {columns[2].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 2)}>
                                <div>{data[2]}</div>
                           </TableCell>)}
                           {columns[3].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 3)}>
                                <Tooltip title={data[3] ?? ''}>
                                    {/*<div style={{color: '#C42828', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '500px', whiteSpace: 'nowrap', wordWrap: 'break-word'}}>{data[3]}</div>*/}
                                    <div style={{color: '#C42828', lineHeight: 1.2, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis'}}>{data[3]}</div>
                                </Tooltip>
                           </TableCell>)}
                           {columns[4].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 4)}>
                                <div>{data[4]}</div>
                           </TableCell>)}
                           {columns[5].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 5)}>
                                <div>{data[5]}</div>
                           </TableCell>)}
                           {columns[6].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 6)}>
                           { data[6] !== undefined && data[6] !== null &&
                            data[8] !== undefined && data[8] !== null ?
                                <div>{data[6]}% [{data[8]}]<br/>Updated: {data[9]}</div>
                                :
                                <div></div>
                              }
                           </TableCell>)}
                           {columns[10].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 10)}>
                                <div>{data[10]}</div>
                           </TableCell>)}
                           {columns[11].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 11)}>
                                <div>{data[11]}</div>
                           </TableCell>)}
                           {columns[12].options.display && (
                           <TableCell onClick={() => onCellClick(dataIndex, 12)}>
                                <div>{data[12]}</div>
                           </TableCell>)}
                           {columns[columns.length - 1].options.display && (
                            <TableCell onClick={() => onCellClick(dataIndex, columns.length - 1)}>
                                <div>
                                    <IconButton color="primary"
                                          component="span"
                                          onClick={handleClick}>
                                        <MoreVertIcon />
                                    </IconButton>
                                </div>
                            </TableCell>)}
                       </TableRow>
                     );
             },
             onViewColumnsChange: (changedColumn, action) => {
               var newCols = columns.map(col => {
                 let newCol = Object.assign({}, col);
                 if (changedColumn === newCol.name) {
                   if (action === "add") {
                     newCol.options.display = true;
                   } else {
                     newCol.options.display = false;
                   }
                 }
                 return newCol;
               });
               setColumns(newCols);
               localStorage.setItem('customers_columns_hide',JSON.stringify(newCols.map((c,i) => c.options && c.options !== null && c.options.display !== undefined && c.options.display !== null && !c.options.display ? i : -1).filter(o => o >= 0)));
             }
            }}
          />
        </MuiThemeProvider>
      </Grid>
      </Grid>

      {<StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}

        >
          <StyledMenuItem onClick={handleOpenCreateSiteDialog}>
            <ListItemIcon>
              <BusinessIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Create Site" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadHistory}>
            <ListItemIcon>
              <HistoryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download History" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadPricingHistory}>
            <ListItemIcon>
              <HistoryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download Pricing History" />
          </StyledMenuItem>
          {data !== undefined && data !== null && selectedRowIndex >= 0 && data[selectedRowIndex].xero_contact_id !== undefined &&
           data[selectedRowIndex].xero_contact_id !== null &&
           <StyledMenuItem onClick={resetXeroContactConfirmation}>
            <ListItemIcon>
              <RemoveCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Reset Xero Contact" />
          </StyledMenuItem>}
          <StyledMenuItem onClick={downloadCustomerAssetsCSV}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View Assets CSV" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadCustomerCostEstimatorCSV}>
            <ListItemIcon>
              <MonetizationOnIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View Cost Estimate CSV" />
          </StyledMenuItem>
          <StyledMenuItem onClick={viewCustomerForecast}>
            <ListItemIcon>
              <CardMembershipIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View Forecast" />
          </StyledMenuItem>
        </StyledMenu>}

      <Dialog open={openCreateCustomerDialog} onClose={handleCloseCreateCustomerDialog} disableBackdropClick={true} maxWidth="lg"

          PaperProps={{
            style: {
              boxShadow: 'none',
              width: '100%'
            },
          }}
      >
        <DialogTitle className={classes.title}>CREATE CUSTOMER</DialogTitle>
            <DialogContent>
                    <CreateCustomer ref={createCustomerRef}
                            createdCustomer={createdCustomer}
                            onFormUpdated={onCreateCustomerFormUpdated}
                            onCustomerUpdated={onCreateCustomerUpdated}
                            onCustomerCreated={onCustomerCreated}/>

        </DialogContent>
        <DialogActions>
            <Button onClick={handleCloseCreateCustomerDialog}>
              Cancel
            </Button>
            <Button onClick={createCustomer} disabled={isCreatingCustomer || !isCreateCustomerValid}>
              {isCreatingCustomer && <span><CircularProgress size={25} color={'inherit'} /> Creating Customer...</span>}
              {!isCreatingCustomer && <span>CREATE</span>}
            </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCreateSiteDialog} onClose={handleCloseCreateSiteDialog} disableBackdropClick={true} maxWidth="lg"

          PaperProps={{
            style: {
              boxShadow: 'none',
              width: '100%'
            },
          }}
      >
        <DialogTitle className={classes.title}>CREATE SITE</DialogTitle>
            <DialogContent>
                <DialogContentText>
                  <CreateSite ref={createSiteRef}
                            createdSite={createdSite}
                            onFormUpdated={onCreateSiteFormUpdated}
                            onSiteUpdated={onCreateSiteUpdated}
                            onSiteCreated={onSiteCreated}/>
            </DialogContentText>

        </DialogContent>
        <DialogActions>
            <Button onClick={handleCloseCreateSiteDialog}>
              Cancel
            </Button>
            <Button onClick={createSite} disabled={isCreatingSite || !isCreateSiteValid}>
              {isCreatingSite && <span><CircularProgress size={25} color={'inherit'} /> Creating Site...</span>}
              {!isCreatingSite && <span>CREATE</span>}
            </Button>
        </DialogActions>
      </Dialog>
      <CustomerDownloadCSVConfirmation ref={customerDownloadCSVConfirmationRef}
                        closeMenu={handleClose}/>

    </>
  );
});

export default Customers;
